// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__umolI","close":"styles_close__V4uQO","inner":"styles_inner__NMawS"};